/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
// @ts-nocheck
import React, { Suspense, lazy, useEffect } from "react";
import {
    BrowserRouter as Router,
    Redirect,
    Route,
    Switch
} from "react-router-dom";
import { VApplication } from "../application";
import { I18nextProvider } from "react-i18next";
import  i18n  from "../components/translation";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";
import { AuthService } from "../services";
import { lazyWithRetry} from "./ComponentLoader";

const UserOptions   = lazyWithRetry(() => import( "../pages/Options"));
const Application  = lazyWithRetry(() => import( "../pages/NewEpccApplication"));
 const DownloadEPCC = lazyWithRetry(() => import( "../pages/DownloadScreen"));
const ApplicationStatus= lazyWithRetry(() => import( "../pages/ApplicationStatus"));
const LandingPage = lazyWithRetry(() => import("../pages/Landing"));
const SignUpUser = lazyWithRetry(() => import("../pages/SignUp"));
const SignInUser = lazyWithRetry(() => import("../pages/SignIn"));
const Instructions = lazyWithRetry(() => import("../pages/NewEpccInstructions"));
const ResetPassword = lazyWithRetry(() => import('../pages/ResetPassword'));
const userProfile = lazyWithRetry(() => import('../pages/Profile'));
const EmailVerification = lazyWithRetry(() => import('../pages/EmailVerification'));
const ApplicationList = lazyWithRetry(() => import('../pages/ApplicationList'));
const UpdateEpccApplication = lazyWithRetry(() => import('../pages/UpdateEpccApplication'));

const loginService = VApplication.getInstance().getSync(
    "services.AuthService"
) as AuthService;

const RouterConfig = (props) => {
    return(
    <Switch>
        <Route path='/creds/create-account' component={SignUpUser} />
        <Route exact path="/" component={SignInUser} />
        <Route exact path="/signup" component={SignUpUser} />
        <Route exact path='/forgot-password' component={ResetPassword} />
        <Route exact path='/email-verification' component={EmailVerification} />
        
        <PrivateRoute path='/options' component={UserOptions} />
        <PrivateRoute path="/profile" component={userProfile} />
        <PrivateRoute path="/new-epcc-instructions" component={Instructions}/>
        <PrivateRoute path="/new-epcc-application" component={Application} />
        <PrivateRoute path='/download-epcc' component={DownloadEPCC}/>
        <PrivateRoute path='/application-status' component={ApplicationStatus} />
        <PrivateRoute path='/application-list' component={ApplicationList} />
        <PrivateRoute path='/application-update' component={UpdateEpccApplication} />
        <Redirect to={{pathname:'/'}} />
    </Switch>
    )
};

const PrivateRoute = ({ component: Component, ...rest }) => (

        <Route
        {...rest}
        render={(props) =>
            loginService.isAuthenticated() ? (<Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/`,
                    }}
                />
            )
        }
    />
);

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}

export const AppNavigator = (): JSX.Element => {
    return (
        <Router>
             <I18nextProvider i18n={i18n}>
                <Suspense fallback={null}>
                    <RouterConfig />
                </Suspense>
            </I18nextProvider>
        </Router>
    );
};
